<template>
  <div>
    <el-dialog
      title="新增合服任务"
      center
      :visible="true"
      @close="onClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="440px"
    >
      <el-form
        ref="form"
        :model="form"
        label-position="left"
        label-width="90px"
        size="mini"
      >
        <el-form-item label="分区范围：">
          <el-input v-model="form.minZoneId" style="width: 100px"></el-input>
          ~
          <el-input v-model="form.maxZoneId" style="width: 100px"></el-input>
        </el-form-item>

        <el-form-item label="主分区：">
          <el-input v-model="form.masterZoneId" style="width: 100px"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button @click="onClose" style="margin-left: 0px">取消</el-button>
          <el-button
            type="primary"
            icon="el-icon-warning-outline"
            @click="mergeZone()"
            style="margin-left: 20px"
            >确认</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";
import { max } from "moment";
const dialogutil = require("@/dialogutil");

// 本弹窗名称
const DialogName = "MergeZonesDialog";

export default {
  data() {
    return {
      form: {
        masterZoneId: "",
        minZoneId: "",
        maxZoneId: "",
      },
    };
  },

  async created() {},

  methods: {
    async mergeZone() {
      let masterZoneId = Number(this.form.masterZoneId);
      if (masterZoneId.toString() == "NaN") {
        this.$alert("请检查输入，输入的值必须是数字", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      let minZoneId = Number(this.form.minZoneId);
      if (minZoneId.toString() == "NaN") {
        this.$alert("请检查输入，输入的值必须是数字", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      let maxZoneId = Number(this.form.maxZoneId);
      if (maxZoneId.toString() == "NaN") {
        this.$alert("请检查输入，输入的值必须是数字", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }

      try {
        // 弹确认框
        await this.$confirm(
          `确认将分区范围[${minZoneId},${maxZoneId}]合入到分区${masterZoneId}？`
        );
        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/v1/admin/mergeZones`,
            {
              masterZone: masterZoneId,
              zoneRange: [minZoneId, maxZoneId],
            },
            {
              headers: {
                token: bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message({
            message: resData.message,
            type: "error",
          });
          return;
        }
        this.$message({
          message: "成功",
          type: "success",
        });

        this.onClose();
      } catch (e) {}
    },

    onClose() {
      // 关闭当前对话框
      this.$dialogutil.close(DialogName);
    },
  },
};
</script>